import React, { createContext, useContext, useState, useCallback } from "react";
import { translations, LANGUAGES, CATEGORY_NAMES } from "@/i18n/translations";
import { EXTRA } from "@/i18n/extra";
import { EXTRA2 } from "@/i18n/verify";

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("ppc_lang") || "en");

  const setLang = useCallback((code) => {
    localStorage.setItem("ppc_lang", code);
    setLangState(code);
  }, []);

  const t = useCallback(
    (key) => {
      const dict = { ...(translations.en || {}), ...(EXTRA.en || {}), ...(EXTRA2.en || {}), ...(translations[lang] || {}), ...(EXTRA[lang] || {}), ...(EXTRA2[lang] || {}) };
      return dict[key] ?? key;
    },
    [lang]
  );

  const tc = useCallback(
    (categoryKey) => {
      const dict = CATEGORY_NAMES[lang] || CATEGORY_NAMES.en;
      return dict[categoryKey] ?? CATEGORY_NAMES.en[categoryKey] ?? categoryKey;
    },
    [lang]
  );

  const td = useCallback(
    (dayKey) => {
      const dict = translations[lang] || translations.en;
      return (dict.days && dict.days[dayKey]) || translations.en.days[dayKey] || dayKey;
    },
    [lang]
  );

  return (
    <LangContext.Provider value={{ lang, setLang, t, tc, td, languages: LANGUAGES }}>
      {children}
    </LangContext.Provider>
  );
}

export const useLang = () => useContext(LangContext);
